export const redirectPath = {
  pdpaola: {
    SC001: 'pdpaola-markets',
    SC002: 'pdpaola-globale',
    SC003: 'pdpaola-outlet',
    SC004: 'pdpaola-events',
    SC005: 'pdpaola-uk',
    SC006: 'pdpaola-it',
    SC007: 'pdpaola-eci',
    SC008: 'pdpaola-coin',
    SC009: 'pdpaola-printemps',
    SC010: 'pdpaola-soldtrhough',
    SC011: 'pdpaola-us',
    FR001: 'pdpaola-tamkeen',
    FR002: 'pdpaola-regency',
    FR003: 'pdpaola-kronotime',
    FR004: 'pdpaola-andorra',
    FR005: 'pdpaola-ibiza',
    FR006: 'pdpaola-reinhold',
    FR007: 'pdpaola-chile',
    FR008: 'pdpaola-quantum'
  },
  'pdpaola-warranty': {
    SC001: 'pdpaola-markets-warranty',
    SC002: 'pdpaola-globale-warranty',
    SC003: 'pdpaola-outlet-warranty',
    SC004: 'pdpaola-events-warranty',
    SC005: 'pdpaola-uk-warranty',
    SC006: 'pdpaola-it-warranty',
    SC007: 'pdpaola-eci-warranty',
    SC008: 'pdpaola-coin-warranty',
    SC009: 'pdpaola-printemps-warranty',
    SC010: 'pdpaola-soldtrhough-warranty',
    SC011: 'pdpaola-us-warranty',
    FR001: 'pdpaola-tamkeen-warranty',
    FR002: 'pdpaola-regency-warranty',
    FR003: 'pdpaola-kronotime-warranty',
    FR004: 'pdpaola-andorra-warranty',
    FR005: 'pdpaola-ibiza-warranty',
    FR006: 'pdpaola-reinhold-warranty',
    FR007: 'pdpaola-chile-warranty',
    FR008: 'pdpaola-quantum-warranty'
  },
  'pdpaola-cancelations': {
    SC001: 'pdpaola-markets-cancelation',
    SC002: 'pdpaola-globale-cancelation',
    SC003: 'pdpaola-outlet-cancelation',
    SC004: 'pdpaola-events-cancelation',
    SC005: 'pdpaola-uk-cancelation',
    SC006: 'pdpaola-it-cancelation',
    SC007: 'pdpaola-eci-cancelation',
    SC008: 'pdpaola-coin-cancelation',
    SC009: 'pdpaola-printemps-cancelation',
    SC010: 'pdpaola-soldtrhough-cancelation',
    SC011: 'pdpaola-us-cancelation',
    FR001: 'pdpaola-tamkeen-cancelation',
    FR002: 'pdpaola-regency-cancelation',
    FR003: 'pdpaola-kronotime-cancelation',
    FR004: 'pdpaola-andorra-cancelation',
    FR005: 'pdpaola-ibiza-cancelation',
    FR006: 'pdpaola-reinhold-cancelation',
    FR007: 'pdpaola-chile-cancelation',
    FR008: 'pdpaola-quantum-cancelation'
  }
}
